import { lettersPageActionTypes } from '@actions/actionTypes/lettersPage';
import { lettersPageInitialState, LettersPageState } from './initialState/lettersPage';
import { AnyAction } from 'redux';

export const lettersPageReducer = (
  state = lettersPageInitialState,
  action: AnyAction
): LettersPageState => {
  switch (action.type) {
    case lettersPageActionTypes.SET_IS_OPEN_SAVE_AS_MODAL: {
      return { ...state, isOpenSaveAsModal: action.payload };
    }
    case lettersPageActionTypes.SET_IS_OPEN_DOWNLOAD_MODAL: {
      return { ...state, isOpenDownloadModal: action.payload };
    }
    case lettersPageActionTypes.SET_IS_OPEN_DELETE_MODAL: {
      return { ...state, isOpenDeleteModal: action.payload };
    }
    case lettersPageActionTypes.SET_IS_OPEN_MULTIPLE_DELETE_MODAL: {
      return { ...state, isOpenMultipleDeleteModal: action.payload };
    }
    case lettersPageActionTypes.SET_IS_OPEN_CHANGE_TYPE_MODAL: {
      return { ...state, isOpenChangeTypeModal: action.payload };
    }
    case lettersPageActionTypes.SET_IS_OPEN_REASSIGN_GROUP_MODAL: {
      return { ...state, isOpenReassignGroupModal: action.payload };
    }
    case lettersPageActionTypes.SET_FILTERS: {
      return { ...state, filters: action.payload };
    }
    default: {
      return state;
    }
  }
};
